import { TypedDocumentNode } from 'providers/tanstack-query/types'
import { gql } from 'providers/tanstack-query/utils'
import { EMPLOYEE_FRAGMENT } from './fragment'
import { Data, Variables } from './types'

export const GET_EMPLOYEE: TypedDocumentNode<Data, Variables> = gql`
  ${EMPLOYEE_FRAGMENT}

  query getEmployee($id: ID!) {
    node(id: $id) {
      ... on User {
        ...EmployeeFragment
      }
    }
  }
`
